<breadcrumb endText="System Management" />
<div class="m-8 gap-5">
  <div class="flex justify-between items-center mb-2">
    <h1 class="font-medium text-xl">
      System Management
    </h1>
    <clear-button text="View Logs" (click)="router.navigate(['dashboard/SystemManagement/logs'])" />
  </div>
  <hr />
  <div class="">
    <button (click)="router.navigate(['dashboard/SystemManagement/lists'])" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center float-left text-sm font-medium" id="orglist">
      System Lists
    </button>
    <button (click)="systemBrandingClick()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center float-left text-sm font-medium" id="branding">
      System Branding
    </button>
    <button (click)="announcementsClick()" class="border rounded-2xl min-w-[196px] h-[152px] m-5 p-1.5 flex items-end justify-center float-left text-sm font-medium" id="announcements">
      Announcements
    </button>
  </div>
</div>
